import { add, isAfter, isWeekend, parseISO } from 'date-fns'
import { format } from 'date-fns'
import { formatPrice } from '@lib/formatPrice'

// Diamond Experience Tour:
// Starting today:
// Every day, each half hour from 09:00 - 16:45
// Example: (09:00, 09:30, ... 16;00, 16:30, 16:45)

// GASSAN VIP Tour:
// Starting 3 days later:
// Mo-Fr each half hour from 09:00 - 15:00
// On weekends each half hour from 09:00 - 13:00

// Diamond Polishing Experience:
//  Starting 2 weeks later:
// All week, but only at 10:00 or 14:00 o'clock

export const getIsDateBlocked = (codename: string) => {
  if (codename === 'gassan_vip_tour') {
    const now = add(new Date(), { days: 2 })
    return (date: Date) => isAfter(now, date)
  } else if (codename === 'diamond_polishing_experience_tour') {
    const now = add(new Date(), { days: 14 })
    return (date: Date) => isAfter(now, date)
  }
}
let vipTourWeekDayTimes = []
for (let i = 9; i < 16; i++) {
  vipTourWeekDayTimes.push({ label: `${i}:00`, value: `${i}:00` })
  if (i !== 15) {
    vipTourWeekDayTimes.push({ label: `${i}:30`, value: `${i}:30` })
  }
}
let vipTourWeekendTimes = []
for (let i = 9; i < 14; i++) {
  vipTourWeekendTimes.push({ label: `${i}:00`, value: `${i}:00` })
  if (i !== 13) {
    vipTourWeekendTimes.push({ label: `${i}:30`, value: `${i}:30` })
  }
}

export const getTimes = (codename: string, date: string) => {
  const reversed = date.split('-').reverse().join('-')
  const isWeekendDay = isWeekend(parseISO(reversed))
  if (codename === 'gassan_vip_tour') {
    if (date === '' || !isWeekendDay) {
      return vipTourWeekDayTimes
    } else {
      return vipTourWeekendTimes
    }
  } else if (codename === 'diamond_polishing_experience_tour') {
    return [
      {
        label: '10:00',
        value: '10:00'
      },
      {
        label: '14:00',
        value: '14:00'
      }
    ]
  } else {
    // if today, only return times that are still bookable
    const start = date === format(new Date(), 'dd-MM-yyyy') ? new Date().getHours() + 1 : 10
    let times = []
    for (let i = start; i < 17; i++) {
      times.push({ label: `${i}:00`, value: `${i}:00` })
    }
    times.push({ label: `16:30`, value: `16:30` })
    times.push({ label: `16:45`, value: `16:45` })
    return times
  }
}

export const getTourTitle = (codename: string): string => {
  if (codename === 'gassan_vip_tour') {
    return 'VIP tour'
  }
  if (codename === 'diamond_polishing_experience_tour') {
    return 'Diamond Polishing Experience Tour'
  }
  if (codename === 'diamond_and_champagne_tour') {
    return 'Diamond & Champagne Tour'
  }
  if (codename === 'diamond_experience_tour') {
    return 'Diamond experience tour'
  }
}

export const getPriceDisplay = (price: number, persons: string, lang: string) => {
  if (price === 0) {
    return lang === 'nl' ? ' - Gratis' : '- Free'
  }

  if (persons === '') {
    return ''
  }

  const cents = parseInt(persons, 10) * price
  return ` - ${formatPrice(cents)}`
}

export const getPricePerTicket = (codename: string): number => {
  if (codename === 'gassan_vip_tour') {
    return 3500
  }
  if (codename === 'diamond_polishing_experience_tour') {
    return 40000
  }
  return 0
}

export const getPersons = (mode: string, codename: string): any => {
  let persons = []
  let max = 8
  let min = 1
  if (mode === 'tour-operator') {
    max = 51
  }
  if (codename === 'gassan_vip_tour') {
    max = 7
  }
  if (codename === 'diamond_polishing_experience_tour') {
    min = 2
    max = 5
  }
  for (let i = min; i < max; i++) {
    persons.push({ label: i, value: i })
  }
  return persons
}
